import React, {Component} from 'react';
import {JSONFILE} from '../../resources/constant';
import {viewTabular} from '../../Utilities/WSUtil';

import Table from 'react-bootstrap/Table';

export default class ViewTabularFile extends Component{

    constructor(props){
        super(props);        
        this.state = { 
            fileName: JSON.parse(localStorage.getItem(JSONFILE)).file,
            file:'',
            merchantId:'',
            nonsm: true,
            settlement: true,
            smdept: true,
            ssbdo: true,
            sibdo: true,
            fgbdo: true,
            mpbdo: true,
            tabular: []            
        }
    }


    componentWillMount(){       
        viewTabular(localStorage.getItem(JSONFILE)).then(response =>                      
            {                
                this.setState({
                    file: response.type, 
                    merchantId:response.tabular[0].merchantId, 
                    tabular: response.tabular});                
                    this.setFileType(this.state.file);    
            }                        
        )
        
    }

    setFileType(ft){        
        if(ft === 'nonsm'){
            this.setState({
                nonsm :false
            })
        }else if(ft === 'settlement'){
            this.setState({
                settlement:false
            })
        }else if(ft === 'smdept'){
            this.setState({
                smdept: false,
            })
        }else if(ft === 'ssbdo'){
            this.setState({
                ssbdo: false
            })
        }else if(ft ==='fgbdo'){
            this.setState({
                fgbdo: false,
            })
        }else if(ft === 'mpbdo'){
            this.setState({
                mpbdo: false
            })
        }
    }
    render(){
        return(
            <div align="center">

                <div style={{background:'#0B2972', height:"30px"}}>
                    <div align="center">
                        <span style={{color:'#FFFFFF', textAlign:'center', verticalAlign:'middle'}} >
                            <font style={{color:'#FFFFFF', fontSize:'14px', fontWeight:'bold',  verticalAlign:'middle'}}>
                                {this.state.fileName}
                            </font>
                        </span>
                    </div>                
                </div>

                <div hidden={this.state.ssbdo}>
                    <Table>
                        
                    </Table>
                    

                </div>
                

                <div hidden={this.state.smdept}>
                    <Table stripped bordered hover style={{width:'100%', fontFamily: 'Verdana, Arial, Helvetica, sans-serif', fontSize:'11px', border:'2'}} size="sm">	   		                                                                                     
                            {this.state.tabular.map(x => 
                            <tbody key={x.merchantId}>    
                            <tr>
   		                        <td width="25%"><b>Merchant Number : </b></td>
   		                        <td width="25%" align="left">{x.merchantId}</td>
   		                        <td width="25%"><b>MDS Number : </b></td>
   		                        <td width="25%" align="left">{x.mdsNumber}</td>
   	                        </tr>
                            <tr>
                                <td width="25%"><b>Extraction Date : </b></td>
                                <td width="25%" align="left">{x.extractionDate}</td>
                                <td width="25%"><b>Terminal ID : </b></td>
                                <td width="25%" align="left">{x.terminalId}</td>
                            </tr>
                            <tr>
                                <td width="25%"><b>No of Transactions :</b></td>
                                <td width="25%" align="left">{x.totalCount}</td>
                                <td width="25%"><b>Currency Code : </b></td>
                                <td width="25%" align="left">{x.currCode}</td>
                            </tr>
                            <tr>
                                <td width="25%"><b>Total Tran Amount : </b></td>
                                <td width="25%" align="left">{x.totalPay}</td>
                                <td width="25%"><b>Device Type : </b></td>
                                <td width="25%" align="left">{x.deviceType}</td>
                            </tr>
                            </tbody>                               
                            )}
                    </Table>
                </div>


                <div hidden={this.state.settlement} style={{marginTop:'50px'}}>
                    <Table stripped bordered hover style={{width:'100%', fontFamily: 'Verdana, Arial, Helvetica, sans-serif', fontSize:'11px', border:'2'}} size="sm">	   		                                       
                        <tbody>
                        <tr>
                            <td align="center"><b>Terminal ID</b></td>
                            <td align="center"><b>Batch Number</b></td>
                            <td align="center"><b>Settlement Number</b></td>
                            <td align="center"><b>Card Number</b></td>
                            <td align="center"><b>Transaction Date</b></td>
                            <td align="center"><b>Transaction Amount</b></td>	   		  
                            <td align="center"><b>Approval Code</b></td>
                            <td align="center"><b>MDR</b></td>
                            <td align="center"><b>Discount Amount</b></td>	   				
	   		            </tr>							
                        {this.state.tabular.map(x =>    
                        <tr key={x.appCode}>
                            <td align="center">{x.terminalId}</td>
                            <td align="center">{x.posBatchNumber}</td>
                            <td align="center">{x.settlementNumber}</td>
                            <td align="center">{x.cardNumber}</td>
                            <td align="center">{x.transactionDate}</td>
                            <td align="right">{x.billAmount}</td>
                            <td align="center">{x.appCode}</td>
                            <td align="center">{x.mdr}</td>
                            <td align="right">{x.discountAmount}</td>
                        </tr>                        
                       )}
                       </tbody>	   				   		
	                </Table>
                </div>

                <div hidden={this.state.nonsm}>
                    <div align="center" style={{marginTop:'50px', paddingBottom:'20px', fontFamily: 'Verdana, Arial, Helvetica, sans-serif'}}>
                            <span style={{textAlign:'center'}} >                            
                                <b>Credit Card Transaction of Merchant : {this.state.merchantId}</b>                            
                            </span>
                    </div>
                    <Table stripped bordered hover style={{width:'60%', fontFamily: 'Verdana, Arial, Helvetica, sans-serif', fontSize:'11px', border:'2'}} size="sm">                    
                        <tbody>
                            <tr>
                                <td align="center" width="10%"><b>Terminal Number</b></td>
                                <td align="center" width="9%"><b>Invoice Date</b></td>
                                <td align="center" width="14%"><b>Account Number</b></td>
                                <td align="center" width="9%"><b>Amount</b></td>
                                <td align="center" width="9%"><b>Auth Code</b></td>                        
                                <td align="center" width="9%"><b>POS Batch No</b></td>                                                
                            </tr>                              
                                
                            {this.state.tabular.map(a => 
                                    <tr key={a.authCode}>
                                        <td>{a.terminal}</td>                                        
                                        <td>{a.transactionDate}</td>                                            
                                        <td>{a.cardNumber}</td>
                                        <td align="right">{a.billAmount}</td>
                                        <td>{a.authCode}</td>
                                        <td>{a.posBatchNumber}</td>                                        
                                    </tr>                                
                                    )
                            }                                                                                                  
                        </tbody>
                    </Table>                
                    </div>                        
            </div>
        )
    }




}